/**
 * The confirmation shown before a trade is removed, from the skill routing view or the
 * schedule assignment board. Its assignments go too (FIQ-2457), which sends that work
 * back to skill routing, so the board's left-hand list gets those schedules back. So do
 * conditional rules sending work to it, and every rule on its own skills, which the server
 * drops without a trace.
 *
 * @param {{ tradeName: string, skillCount: number, assignmentCount: number | null, conditionalRuleCount?: number }} counts
 *   assignmentCount is null when it could not be read; conditionalRuleCount is the number
 *   of skills that lose conditional rules with the trade (0 or missing adds nothing)
 * @returns {string}
 */
export function removeTradeMessage({ tradeName, skillCount, assignmentCount, conditionalRuleCount }) {
    const skills = `Remove trade "${tradeName}"? Its ${skillCount} ${"skill".pluralize(skillCount)} will become unmapped.${describeConditionalRules(conditionalRuleCount)}`
    if (assignmentCount === null) {
        return `${skills} Any schedule assignments it has will also be removed, so that work goes back to skill routing.`
    }
    if (!assignmentCount) return skills
    const assignments = `${assignmentCount} ${"schedule assignment".pluralize(assignmentCount)}`
    return `${skills} Its ${assignments} will also be removed, so that work goes back to skill routing.`
}

function describeConditionalRules(conditionalRuleCount) {
    if (!conditionalRuleCount) return ""
    return ` Conditional rules on ${conditionalRuleCount} ${"skill".pluralize(conditionalRuleCount)} will be removed too: rules that send work to this trade, and every rule on its own skills.`
}
